import Item from './Item';
import Container from './Container';

export default Object.assign(Container, { Item });
